<template>
  <DateFilter @filter="onFilter" @clear="onClear" />
</template>
<script>
import {EventNames} from "@/plugins/enums";
import DateFilter from '@/components/shared/Filters/Date-filter.vue'

export default {
    name: 'MeetingDate',

    components: {
        DateFilter
    },

    methods: {
        onClear() {
            this.$eventBus.$emit(EventNames.ClearMeetingsFilter);
        },

        onFilter(interval) {
            this.$eventBus.$emit(EventNames.FilterMeetingsByDate, interval);
        }
    }
}
</script>
